
<div class="headline">{{config.headline}}</div>
<div class="content">
  <div [innerHTML]="config.text"></div>

  @if (config.showFeedbackInline) {
    <div class="mt-4 p-3 bg-blue-50 border border-blue-200 rounded flex items-center justify-between">
      <span class="text-base font-medium">War die Fehlererkennung korrekt?</span>
      <div class="flex gap-2">
          <button
                  class="button-base !p-2 !min-w-0"
                  [class.button-primary]="feedback === true"
                  [class.bg-white]="feedback !== true"
                  (click)="selectFeedback(true)"
                  [title]="config.confirmButtonText">

              <i class="fa {{ config.confirmIcon }}"></i>
          </button>

          <button
                  class="button-base !p-2 !min-w-0"
                  [class.button-primary]="feedback === false"
                  [class.bg-white]="feedback !== false"
                  (click)="selectFeedback(false)"
                  [title]="config.cancelButtonText">

              <i class="fa {{ config.cancelIcon }}"></i>
          </button>
      </div>
    </div>
  }
</div>

<div class="mt-6 flex justify-end gap-2">
  @if (config.saveButtonText) {
    <button class="button-base button-primary" [mat-dialog-close]="'save'">
      {{config.saveButtonText}}
    </button>
  }

  @if (!config.showFeedbackInline) {
    <button class="button-base button-primary" mat-dialog-close="true">

      {{config.confirmButtonText}}
    </button>

    @if (!config.hideCancelButton) {
      <button class="button-base button-secondary bg-secondary" mat-dialog-close>
        {{config.cancelButtonText}}
      </button>
    }
  } @else {
    <button class="button-base button-secondary bg-secondary" mat-dialog-close>
      Abbrechen
    </button>
  }
</div>
